import {View} from 'react-native'
import {useLingui} from '@lingui/react/macro'

import {useSuggestedClassroomsQuery} from '#/state/queries/classrooms/search'
import {useSession} from '#/state/session'
import {ClassroomCard} from '#/screens/Classroom/components/ClassroomCard'
import {atoms as a} from '#/alf'
import {Circle_And_Square_Stroke1_Corner0_Rounded_Filled as ClassroomIcon} from '#/components/icons/CircleAndSquare'
import * as ModuleHeader from '../components/ModuleHeader'

const MAX_SUGGESTED = 5

export function ExploreClassrooms() {
  const {t: l} = useLingui()
  const {hasSession} = useSession()
  const {data} = useSuggestedClassroomsQuery()

  if (!hasSession || !data?.length) return null

  return (
    <View>
      <ModuleHeader.Container>
        <ModuleHeader.Icon icon={ClassroomIcon} />
        <ModuleHeader.TitleText>{l`Classrooms for you`}</ModuleHeader.TitleText>
      </ModuleHeader.Container>
      <View style={[a.px_lg, a.gap_md]}>
        {data.slice(0, MAX_SUGGESTED).map(classroom => (
          <ClassroomCard key={classroom.id} classroom={classroom} />
        ))}
      </View>
    </View>
  )
}
